import { pushAnalyticsEvent } from '../../utils/googleAnalytics'
import { Logo } from '../Logo'
import Youtube from '../../images/icons8-play-button.svg'
import Twitter from '../../images/icons8-twitter.svg'
import Facebook from '../../images/icons8-facebook.svg'
import LinkedIn from '../../images/icons8-linkedin.svg'
import LinkButton from './LinkButton'
import { Link } from 'gatsby'

const Footer = () => {
  return (
    <footer className="primary-dark">
      <div className="row col-xs-12 footer fluid-margin-container">
        <div className="col-xs-12 col-sm-4 footer-left">
          <Link to="/" title="Home" className="footer-logo">
            <Logo labelColor="#FFFFFF" small={false} />
          </Link>
          <p className="footer-tagline">
            The user research and insights platform for design and product teams
          </p>
          <LinkButton url="/free-trial" label="Sign up now" mobile prefetch />
        </div>
        <div className="col-xs-12 col-sm-8 links">
          <ul className="footer-nav">
            <li>
              <Link to="/features">Platform</Link>
            </li>
            <li>
              <Link to="/demo">Demo</Link>
            </li>
            <li>
              <Link to="/pricing">Pricing</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <a href={process.env.BLOG_URL}>Blog</a>
            </li>
            <li>
              <a
                href={process.env.LOGIN_URL}
                className="footer-signin"
                onClick={(): void =>
                  pushAnalyticsEvent('Button', 'Click-Signin')
                }
              >
                Sign In
              </a>
            </li>
          </ul>
          <div className="col-xs-12 footer-contact-links">
            <a
              href="https://twitter.com/aureliuslab"
              target="_blank"
              rel="noreferrer"
              title="Twitter"
            >
              <img src={Twitter} alt="Twitter" className="footer-icon first" />
            </a>
            <a
              href="https://www.facebook.com/aureliuslab"
              target="_blank"
              rel="noreferrer"
              title="Facebook"
            >
              <img src={Facebook} alt="Facebook" className="footer-icon" />
            </a>
            <a
              href="https://www.linkedin.com/company/aurelius"
              target="_blank"
              rel="noreferrer"
              title="LinkedIn"
            >
              <img src={LinkedIn} alt="LinkedIn" className="footer-icon" />
            </a>
            <a
              href="https://www.youtube.com/channel/UCLOUwZ1Ji46A5lE1Xf78Lcg"
              target="_blank"
              rel="noreferrer"
              title="Youtube"
            >
              <img src={Youtube} alt="Youtube" className="footer-icon" />
            </a>
          </div>
          <div className="col-xs-12 col-md-12 footer-contact-links contact-info">
            <a href="mailto:contact@aureliuslab.com">contact@aureliuslab.com</a>
            <a href="tel:(612) 293-0844">(612) 293-0844</a>
          </div>
        </div>
        <div className="col-xs-12 copyright">
          <p className="footer-use-cases">
            <span>Resources: </span>
            <Link to="/user-research-qualitative-data">
              User Research: How to Collect, Organize &amp; Share Qualitative
              Data
            </Link>
          </p>
          <p className="footer-use-cases">
            <span>Explore how Aurelius helps you: </span>
            <Link to="/user-research-synthesis-and-analysis">
              Analyze and Synthesize User Research Data
            </Link>
            <span> — </span>
            <Link to="/user-research-insights-and-nuggets">
              Create Key Insights and Nuggets
            </Link>
            <span> — </span>
            <Link to="/user-research-repository">
              Build a User Research Repository
            </Link>
          </p>
          <div className="footer-copyright">
            © {new Date().getFullYear()} Aurelius Lab, LLC -{' '}
            <Link to="/privacy-policy">Privacy Policy</Link> -{' '}
            <Link to="/security-policy">Security Policy</Link> -{' '}
            <Link to="/responsible-disclosure">Responsible Disclosure</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
export default Footer
